import React from 'react';
import styled from 'styled-components';
import { ModalProps } from '../../../../components/Modal';
import ContainerModal from '../../../../components/ContainerModal';
import { ReactComponent as WarningModal } from '../../../../assets/warningModal.svg';
import { SimpleModal } from '../../../../components/SimpleModal';

type ModalNoEligibilityProps = Pick<ModalProps, 'visible' | 'onClose'>;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #555658;
  text-align: center;
  font-weight: 500;

  h3 {
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    margin-top: 24px;
    font-weight: 500;
  }

  .info1 {
    color: #898b8e;
    font-size: 16px;
    line-height: 24px;
    margin-top: 24px;
  }

  .info2 {
    font-size: 16px;
    line-height: 24px;
    margin-top: 32px;
  }

  .phone-link {
    color: #004f92;
    font-weight: 600;
  }

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`;

const ModalNoEligibility: React.FC<ModalNoEligibilityProps> = ({ visible, onClose }) => {
  return (
    <SimpleModal
      visible={visible}
      onClose={onClose}
      mainIcon={<WarningModal />}
      title="Não foi possível validar sua elegibilidade"
      subtitle='
        <p className="info1">
          Para seguir com o agendamento, entre em contato com a nossa central de atendimento no número
          <a className="phone-link" href="tel:01121511233">
            (11) 2151-1233
          </a>
          .
        </p>
        <br />
        <p className="info2">Atendimento disponível de segunda a sexta, das 7:00 às 19:00, sábado das 7:00 às 13:00, exceto feriados.</p>
    '
    />
  );
};

export default ModalNoEligibility;
